import React from "react"
import PropTypes from "prop-types"
import { Flex, Typography, Avatar, Tooltip } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import { AVATAR_COLORS } from "../constants"
import EmptyState from "components/common/EmptyState"
import styles from "../style.module.css"

const { Text } = Typography

export default function TopCustomersWidget({ data, description }) {
  const { t } = useTranslation()
  const customers = (Array.isArray(data) ? data : []).map((c, i) => {
    const name = c.label ?? "—"
    return {
      rank: c.rank ?? i + 1,
      name,
      initials: name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase(),
      color: AVATAR_COLORS[i % AVATAR_COLORS.length],
      amount: c.value == null ? "—" : `$${Number(c.value).toLocaleString("en-US", { minimumFractionDigits: 2 })}`
    }
  })

  return (
    <div className={styles.widgetContent}>
      <Flex justify="space-between" align="flex-start" className={styles.widgetHeader}>
        <div>
          <Text strong>{t("ai_dashboard.widget_top_customers")}</Text>
          <div><Text type="secondary" className={styles.textSm}>{t("ai_dashboard.by_amount_spent")}</Text></div>
        </div>
        {description && (
          <Tooltip title={description} placement="topRight" styles={{ body: { maxWidth: 320 } }}>
            <InfoCircleOutlined className={styles.widgetInfoIcon} />
          </Tooltip>
        )}
      </Flex>
      <Flex vertical gap="var(--spacing-ss)" className={styles.rankList}>
        {customers.length === 0 ? (
          <div className={styles.widgetEmptyState}>
            <EmptyState title={t("ai_dashboard.no_data")} description=" " />
          </div>
        ) : (
          customers.map((c) => (
            <Flex key={c.rank} align="center" gap={8} className={styles.rankItem}>
              <Text type="secondary" className={styles.rankNum}>{c.rank}</Text>
              <Avatar size={32} className={styles.rankAvatar} style={{ background: c.color }}>{c.initials}</Avatar>
              <Text className={styles.rankName}>{c.name}</Text>
              <Text strong>{c.amount}</Text>
            </Flex>
          ))
        )}
      </Flex>
    </div>
  )
}

TopCustomersWidget.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  description: PropTypes.string,
}
